module.exports = __webpack_public_path__ + "static/media/Subject.6f5eaf8a.svg";